import { render, staticRenderFns } from "./CommonFormContainer.vue?vue&type=template&id=37e1c486&scoped=true"
import script from "./CommonFormContainer.vue?vue&type=script&lang=js"
export * from "./CommonFormContainer.vue?vue&type=script&lang=js"
import style0 from "./CommonFormContainer.vue?vue&type=style&index=0&id=37e1c486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1c486",
  null
  
)

export default component.exports